module.exports = __webpack_public_path__ + "static/media/settings.99e4ef5b.svg";